import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';


export default function WelcomeBot() {
  const [data, setData] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const key = `ccm_welcome_${new Date().toDateString()}`;
    if (sessionStorage.getItem(key)) return;

    fetch('/api/motivational/welcome', { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!d) return;
        setData(d);
        setTimeout(() => setVisible(true), 1200);
        sessionStorage.setItem(key, '1');
      })
      .catch(() => {});
  }, []);

  if (!data || !visible || dismissed) return null;

  const { mensaje, tip, testimonio } = data;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 500,
      maxWidth: 320, width: 'calc(100vw - 48px)',
      animation: 'fadeUp 0.4s ease',
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a0000, #2d0505)',
        border: '1px solid rgba(230,57,70,0.35)',
        borderRadius: 16, padding: '16px 18px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
        marginBottom: 8,
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
          <img src={LOGO} srcSet={LOGO_SRCSET} sizes="36px" alt="Cupido con Mate" style={{ width: 36, height: 36, objectFit: 'contain', flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 10, color: 'rgba(244,162,97,0.8)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>
              Cupido con Mate
            </div>
            <p style={{ fontSize: 13, color: 'white', lineHeight: 1.6, margin: 0 }}>
              {mensaje.icon} {mensaje.msg}
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={() => setDismissed(true)} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 50, padding: '5px 12px', fontSize: 11, color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}>
            Ahora no
          </button>
          <button onClick={() => { setDismissed(true); navigate(mensaje.ruta); }} style={{ background: 'linear-gradient(135deg, #c1121f, #e63946)', border: 'none', borderRadius: 50, padding: '5px 14px', fontSize: 11, fontWeight: 700, color: 'white', cursor: 'pointer' }}>
            {mensaje.cta} →
          </button>
        </div>
      </div>

      {tip && (
        <div style={{ background: '#24170c', border: '1px solid rgba(244,162,97,0.3)', borderRadius: 10, padding: '10px 14px', marginBottom: testimonio ? 6 : 0 }}>
          <div style={{ fontSize: 10, color: 'rgba(244,162,97,0.7)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>💡 Consejo del día</div>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5, margin: '0 0 6px' }}>{tip.tip}</p>
          <button onClick={() => { setDismissed(true); navigate(tip.ruta); }} style={{ background: 'none', border: 'none', color: '#f4a261', fontSize: 11, fontWeight: 700, cursor: 'pointer', padding: 0 }}>
            {tip.accion} →
          </button>
        </div>
      )}

      {testimonio && (
        <div style={{ background: '#0e2117', border: '1px solid rgba(46,213,115,0.25)', borderRadius: 10, padding: '10px 14px' }}>
          <div style={{ fontSize: 10, color: 'rgba(46,213,115,0.7)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>{testimonio.emoji} Así puede empezar tu historia</div>
          <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5, margin: '0 0 4px', fontStyle: 'italic' }}>"{testimonio.historia}"</p>
        </div>
      )}
    </div>
  );
}
